<template>
  <main class="card" role="main">
    <h1>ExampleComponent</h1>
     <router-link :to="{ name: 'home' }">Home</router-link>
  </main>
</template>

<script>
export default {
  name: "ExampleComponent",
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  }
};
</script>

<style scoped>

</style>
